
export const  PaymentStatusEnum = Object.freeze(
 {
    Pending : 0, // Checkout created, payment not confirmed
    Paid : 1, // Payment successful
    Canceled: 2,  // Payment Canceled by user
    Failed: 3,  // Payment failed
    Refunded : 4,// Payment refunded
 })

 export const PaymentStatusLabels = {
  [PaymentStatusEnum.Pending]: "Pending",
  [PaymentStatusEnum.Paid]: "Paid",
  [PaymentStatusEnum.Canceled]: "Canceled",
  [PaymentStatusEnum.Failed]: "Failed",
  [PaymentStatusEnum.Refunded]: "Refunded"
};

export const PaymentStatusColors = {
  [PaymentStatusEnum.Pending]: "orange",
  [PaymentStatusEnum.Paid]: "green",
  [PaymentStatusEnum.Canceled]: "default",
  [PaymentStatusEnum.Failed]: "red",
  [PaymentStatusEnum.Refunded]: "volcano"
};


